import React from 'react'
import AppDevelopmentTypePage from './AppDevelopmentTypePage'
import { appDevelopmentTypeContent } from './appDevelopmentTypeContent'

const FintechAppDevelopment = () => <AppDevelopmentTypePage content={appDevelopmentTypeContent.fintech} />

export default FintechAppDevelopment
